const PAGE_TRANSITION_NAME = 'page'

const PAGE_TRANSITION_DURATION_MS = 250

/* The elements the page transition fades: everything else in a page is header, sidebar or footer. */
const PAGE_FADING_SELECTOR = '.page-hero, .page-content'

export {
  PAGE_FADING_SELECTOR,
  PAGE_TRANSITION_DURATION_MS,
  PAGE_TRANSITION_NAME,
}
